export default class GreenSpacesUtil {
    static getRunoffCoefficientString(runoffCoefficient) {
        if (!runoffCoefficient) return;
        const { min, max } = runoffCoefficient;
        return min === max
            ? `${min}`
            : min
                ? `${min} à ${max}`
                : `< ${max}`;
    }

    static getFields(isPublicFields) {
        let fields = {
            coordinates: true,
            projectReference: true,
            actions: true,
            tags: true,
            surface: true,
            perimeter: true,
            length: true,
            place: true,
            placeExtra: true,
            creationInfos: true,
            modificationInfos: true,
            customReference: true,
            spaceFunction: true,
            spaceType: true,
            dominantComposition: true,
            detailedComposition: true,
            managementClass: true,
            annualMaintenanceFrequency: true,
            isTreeBase: true,
            observation: true,
            vernacularName: true,
            gender: true,
            species: true,
            cultivar: true,
            averageHealthReview: true,
            averageHeight: true,
            averageCircumference: true,
            averageCrownDiameter: true,
            nbTrees: true,
            density: true,
            distanceBetweenTrunks: true,
            woodedAreas: true,
        };

        let formulas = {
            carbonStock: true,
            coolingIndicator: true,
            oxygenProduction: true
        }

        if (isPublicFields) {
            delete fields.actions;
            delete fields.vernacularName;
            delete fields.gender;
            delete fields.species;
            delete fields.cultivar;
            fields = {
                ...fields,
                runoffCoefficient: true,
                essence: true,
            };
        }

        return { ...fields, ...formulas };
    }

    static getMainWoodedArea(woodedAreas) {
        if (!woodedAreas?.length) return null;
        return woodedAreas.sort((a, b) => b.nbTrees - a.nbTrees)[0] || null;
    }

    static getMainWoodedAreaValue(woodedAreas, propertyName) {
        const mainWoodedArea = this.getMainWoodedArea(woodedAreas);
        if (!mainWoodedArea) return null;
        return mainWoodedArea[propertyName];
    }

    static getDefaultProperties() {
        return {
            category: 'Espace vert',
            place: '',
            placeExtra: null,
            customReference: null,
            tagId: [],
            spaceFunctionId: 0,
            spaceTypeCategoryId: 0,
            spaceTypeId: 0,
            dominantCompositionId: 0,
            detailedComposition: null,
            managementClassId: 0,
            annualMaintenanceFrequency: 0,
            isTreeBase: false,
            observations: [],
            woodedAreas: [],
            customFields: {}
        };
    }
}
